import React from 'react';
import '../styles/organisms/agency_registration_application_agreement.scss';

const AgencyRegistrationApplicationAgreement = () => {
  return (
    <div className='AgencyRegistrationApplicationAgreement'>
      <div className='AgencyRegistrationApplicationAgreement__content'>
        ※申請結果のお知らせに3営業日程度のお時間を頂戴しております。申請が混み合った場合には通常よりもお時間を頂戴する可能性がございます。あらかじめご了承ください。
        <br />
        <br />
        代行担当者は、代行先会社に対して会社情報や作業員情報を登録できます。
        <br />
        代行登録操作を行えるユーザーは、代行担当者に設定された協力会社管理者ユーザーのみとなります。
        <br />
        代行担当者は、申請承認後に代行先一覧から追加することもできます。
      </div>
      代行関係の解除は代行先一覧から行えます。
      <div className='AgencyRegistrationApplicationAgreement__links'>
        <div>
          Buildee利用規約：
          <a
            className='clickable-text'
            href='https://service.buildee.jp/support/agreement/'
            target='_blank'
            rel='noreferrer noopener'
          >
            https://service.buildee.jp/support/agreement/
          </a>
        </div>
        <div>
          プライバシーポリシー：
          <a
            className='clickable-text'
            href='https://www.rvsta.co.jp/privacypolicy/'
            target='_blank'
            rel='noreferrer noopener'
          >
            https://www.rvsta.co.jp/privacypolicy/
          </a>
        </div>
      </div>
    </div>
  );
};

export default AgencyRegistrationApplicationAgreement;



// WEBPACK FOOTER //
// ./src/components/AgencyRegistrationApplicationAgreement.jsx